import { Skeleton, Stack, styled } from "@mui/material";

const BuyerSkeleton = () => {

  return (
    <StyledBuyerSkeleton p={2} spacing={1} direction="row">
      <Stack width={{ xs: "100%", md: "60%" }} spacing={0.5}>
        <Stack direction="row" spacing={0.5}>
          <Skeleton variant="rounded" height={60} width={60} />
          <Stack flex={1}>
            <Skeleton variant="text" height={20} width="70%" />
            <Skeleton variant="text" height={20} width="100%" />
            <Skeleton variant="text" height={20} width="50%" />
          </Stack>
        </Stack>
        <Skeleton variant="text" height={20} width="50%" />
        <Skeleton variant="text" height={20} width={60} />
        <Skeleton variant="text" height={20} width={148} />
      </Stack>

      {/* {!isMobile && (
        <Stack width="40%" direction="row" spacing={1}>
          {Array.from(new Array(2)).map((_, index) => (
            <Stack className="rfq" key={index}>
              <Skeleton variant="text" height={20} width="100%" />
              <Divider />
              <Skeleton variant="text" height={20} width={148} />
              <Skeleton variant="text" height={20} width={96} />
              <Skeleton variant="text" height={20} width="70%" />
              <Skeleton variant="text" height={20} width={64} />
            </Stack>
          ))}
        </Stack>
      )} */}
    </StyledBuyerSkeleton>
  );
};

const StyledBuyerSkeleton = styled(Stack)(({ theme }) => ({
  "&, .rfq": {
    backgroundColor: "#fff",
    borderRadius: 8,
    border: "1px solid #eaecf0",
  },
  ".rfq": {
    padding: 8,
    flex: 1,
  },

  [theme.breakpoints.down("md")]: {
    padding: 8,
  },
}));

export default BuyerSkeleton;
